// ============================================
// ADA FIX: Keyboard focus ring detection
//
// Adds 'user-is-tabbing' class to body when
// keyboard navigation is detected. Mouse users
// never see focus rings.
// ============================================
(function () {
  function handleFirstTab(e) {
    if (e.key === 'Tab') {
      document.body.classList.add('user-is-tabbing');
      window.removeEventListener('keydown', handleFirstTab);
      window.addEventListener('mousedown', handleMouseDown);
    }
  }
  function handleMouseDown(e) {
    // ⚠️ FIX: Ignore mousedown on summary/details elements.
    // Empire theme uses <details><summary> for nav dropdowns.
    // Opening them fires a synthetic mousedown which incorrectly
    // removes user-is-tabbing during keyboard navigation.
    var target = e.target;
    if (
      target.tagName === 'SUMMARY' ||
      target.closest('summary') ||
      target.closest('details') ||
      target.closest('.navmenu-link-parent') ||
      target.closest('.site-nav') ||
      target.closest('nav')
    ) {
      return;
    }
    document.body.classList.remove('user-is-tabbing');
    window.removeEventListener('mousedown', handleMouseDown);
    window.addEventListener('keydown', handleFirstTab);
  }
  window.addEventListener('keydown', handleFirstTab);
})();


// ============================================
// ADA FIX: Focus ring styles
//
// Appended to document.body so it lands AFTER
// all theme stylesheets. Gated on
// body.user-is-tabbing so mouse users never
// see focus rings.
// ============================================
function injectFocusStyles() {
  var existingStyle = document.getElementById('ada-focus-fix');
  if (existingStyle) existingStyle.parentNode.removeChild(existingStyle);

  var style = document.createElement('style');
  style.id = 'ada-focus-fix';
  style.innerHTML = [

    // ---- General focus ring for all interactive elements ----
    'body.user-is-tabbing a:focus,',
    'body.user-is-tabbing button:focus,',
    'body.user-is-tabbing input:focus,',
    'body.user-is-tabbing select:focus,',
    'body.user-is-tabbing textarea:focus,',
    'body.user-is-tabbing [tabindex]:focus {',
    '  outline: 3px solid #3b82f6 !important;',
    '  outline-offset: 3px !important;',
    '}',

    // ---- PageFly elements — explicit override to ensure focus ring shows ----
    'body.user-is-tabbing .__pf a:focus,',
    'body.user-is-tabbing .__pf button:focus,',
    'body.user-is-tabbing .__pf input:focus,',
    'body.user-is-tabbing .__pf select:focus,',
    'body.user-is-tabbing .__pf textarea:focus,',
    'body.user-is-tabbing .__pf [tabindex]:focus {',
    '  outline: 3px solid #3b82f6 !important;',
    '  outline-offset: 3px !important;',
    '}',

    // ---- Product detail page price focus ring ----
    // When the hidden summary element is focused, rings appear on
    // the visible h1 title and price block instead.
    'body.user-is-tabbing h1.ada-detail-focused,',
    'body.user-is-tabbing .product-block--price.ada-detail-focused {',
    '  outline: 3px solid #3b82f6 !important;',
    '  outline-offset: 6px !important;',
    '  border-radius: 8px !important;',
    '}',
    // Keep the hidden summary element invisible always
    '#ada-product-summary:focus {',
    '  outline: none !important;',
    '}',
    // Skip-link landing spot is not a control: no big ring around the content
    '[data-ada-skip-target]:focus {',
    '  outline: none !important;',
    '}',

    // ---- Product card focus ring ----
    // When the title link is focused, draw a ring around the entire
    // product card (image + badge + price + title) so keyboard users
    // can see exactly what product is in focus.
    'body.user-is-tabbing .productgrid--item.ada-card-focused {',
    '  outline: 3px solid #3b82f6 !important;',
    '  outline-offset: 6px !important;',
    '  border-radius: 8px !important;',
    '}',

    // Suppress the default focus ring on the title link itself
    // since the whole-card ring above already shows focus clearly
    'body.user-is-tabbing p.productitem--title a:focus {',
    '  outline: none !important;',
    '}',

    // ---- PageFly circular image links ----
    // Image + label are merged into one <a> by fixPageFlyImageLinks().
    // Rounded rectangle ring hugs both the image and the text label.
    'body.user-is-tabbing a:has(img.pf-image-1):focus {',
    '  outline: 3px solid #3b82f6 !important;',
    '  outline-offset: 6px !important;',
    '  border-radius: 12px !important;',
    '  display: block !important;',
    '}',

    // ---- Empire product card image links ----
    // Empire wraps product images in <a> tags. outline on a block <a>
    // wrapping an <img> is often invisible because the image fills the
    // entire box. box-shadow on the img renders ON TOP — always visible.
    'body.user-is-tabbing .grid-item a:focus img,',
    'body.user-is-tabbing .product-item a:focus img,',
    'body.user-is-tabbing .grid__item a:focus img,',
    'body.user-is-tabbing .featured-collection a:focus img,',
    'body.user-is-tabbing .product-card a:focus img,',
    'body.user-is-tabbing a:focus img {',
    '  box-shadow: 0 0 0 3px #fff, 0 0 0 6px #3b82f6 !important;',
    '}',

    // ---- Summary/Details nav dropdowns (Empire theme) ----
    'body.user-is-tabbing summary:focus,',
    'body.user-is-tabbing summary.navmenu-link:focus,',
    'body.user-is-tabbing .navmenu-link-parent:focus {',
    '  outline: 3px solid #3b82f6 !important;',
    '  outline-offset: 3px !important;',
    '}',

    // ---- CBB shipping layout ----
    '.cbb-shipping-rates-calculator-shipping-address-chooser { overflow: visible !important; }',

    // ---- Contrast fixes ----
    '.back-to-top__button-label { color: #1a1a1a !important; }',
    '.site-footer-credits { color: #4a4a4a !important; }',

    // ---- Touch targets ----
    'a.announcement-bar-link { min-height: 44px !important; display: inline-flex !important; align-items: center !important; }',

  ].join('\n');

  document.body.appendChild(style);
}


// ============================================
// ADA FIX: PageFly circular image links
//
// PageFly renders category images as <img> tags
// with data-href attributes, and the text label
// below is a separate <h3> with its own <a>.
// This means keyboard users get TWO tab stops
// per item (one ring on the image, one rectangle
// on the text) which is redundant and confusing.
//
// This fix merges both into ONE <a> that wraps
// the image and the h3 together — one tab stop,
// one focus ring, one clean aria-label.
//
// Also cleans up keyword-stuffed alt text like
// "Edible Glitter near me | bakell.com" so
// screen readers get a clean label instead.
// ============================================
function fixPageFlyImageLinks() {
  document.querySelectorAll('img.pf-image-1[data-href]').forEach(function (img) {
    if (img.dataset.adaImageFixed === 'true') return;
    img.dataset.adaImageFixed = 'true';

    // Skip if already inside an <a> tag — PageFly already wrapped it
    if (img.closest('a')) return;

    var href   = img.getAttribute('data-href');
    var target = img.getAttribute('data-target') || '_self';

    // Clean keyword-stuffed alt text down to just the product name
    var rawAlt = img.getAttribute('alt') || '';
    var label  = rawAlt.split(' near me')[0].split(' |')[0].trim() || 'View collection';

    // Image is decorative — the <a> aria-label carries the name
    img.setAttribute('alt', '');
    img.setAttribute('aria-hidden', 'true');

    // Find the sibling h3 label inside the same column wrapper
    var column = img.closest('.pf-c');
    var h3     = column && column.querySelector('h3');

    // Build the single wrapper <a>
    var a = document.createElement('a');
    a.href   = href;
    a.target = target;
    a.setAttribute('aria-label', label);
    a.style.display        = 'flex';
    a.style.flexDirection  = 'column';
    a.style.alignItems     = 'center';
    a.style.textDecoration = 'none';

    // Insert <a> before the image, then move image inside it
    img.parentNode.insertBefore(a, img);
    a.appendChild(img);

    // Move h3 inside the same <a>, replacing any inner <a> with a <span>
    // to avoid illegal nested <a><a> markup
    if (h3) {
      var innerLink = h3.querySelector('a');
      if (innerLink) {
        var span       = document.createElement('span');
        span.innerHTML = innerLink.innerHTML;
        span.className = innerLink.className;
        h3.innerHTML   = '';
        h3.appendChild(span);
      }
      a.appendChild(h3);
    }
  });
}


// ============================================
// ADA FIX: Empire quickshop modal
//
// Empire's quickshop opens a modal but does not:
//   1. Trap focus inside it (Tab escapes to page)
//   2. Close on Escape
//   3. Return focus to the triggering card on close
// ============================================
// 10.22.2026 (BKL-134): MODAL_SEL now matches Empire's real modal markup
// (div.modal[data-modal-container], div.modal-1[data-modal-container-1]);
// finds the OPEN modal instead of the first match; and the Escape fallback
// is guarded so the synthetic Escape can't re-enter this handler (it looped).
function fixQuickshop() {
  var MODAL_SEL     = '[data-modal-container], [data-modal-container-1], .modal--quickshop, .quickshop-modal, [data-modal="quickshop"], .modal__inner';
  var CLOSE_BTN_SEL = '.modal__close, .quickshop__close, [data-modal-close], .remodal-close, button[class*="close"]';
  var TRIGGER_SEL   = '.quickshop-trigger, [data-quickshop-trigger], button[class*="quickshop"], a[class*="quickshop"], .product-item__quickshop button, .grid-item__quickshop button';
  var FOCUSABLE_SEL = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var lastTrigger = null;
  var trapActive  = false;
  var closing     = false;

  // The first VISIBLE modal (several modal containers exist, most hidden)
  function getOpenModal() {
    var list = document.querySelectorAll(MODAL_SEL);
    for (var i = 0; i < list.length; i++) {
      if (isModalVisible(list[i])) return list[i];
    }
    return null;
  }

  // Remember which product card button opened the modal
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(TRIGGER_SEL);
    if (trigger) lastTrigger = trigger;
  }, true);

  // Escape + Tab trap
  document.addEventListener('keydown', function (e) {
    if (closing) return; // our own synthetic Escape — let Empire handle it
    var modal = getOpenModal();
    if (!modal) { trapActive = false; return; }
    trapActive = true;

    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      closeModal(modal);
      return;
    }

    if (e.key === 'Tab') {
      var focusable = Array.from(modal.querySelectorAll(FOCUSABLE_SEL)).filter(function (el) {
        return el.offsetParent !== null || window.getComputedStyle(el).position === 'fixed';
      });
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      }
    }
  });

  // Move focus into modal when it opens
  var observer = new MutationObserver(function () {
    var modal = getOpenModal();
    if (modal && !trapActive) {
      trapActive = true;
      setTimeout(function () {
        var closeBtn = modal.querySelector(CLOSE_BTN_SEL);
        var first = closeBtn || modal.querySelectorAll(FOCUSABLE_SEL)[0];
        if (first) first.focus();
      }, 100);
    }
  });
  observer.observe(document.body, {
    childList: true, subtree: true,
    attributes: true, attributeFilter: ['class', 'style', 'aria-hidden']
  });

  function isModalVisible(modal) {
    if (!modal) return false;
    var s = window.getComputedStyle(modal);
    if (s.display === 'none' || s.visibility === 'hidden' || s.opacity === '0') return false;
    if (modal.getAttribute('aria-hidden') === 'true') return false;
    if (modal.classList.contains('is-hidden') || modal.classList.contains('modal--closed')) return false;
    return true;
  }

  function closeModal(modal) {
    trapActive = false;
    var closeBtn = modal.querySelector(CLOSE_BTN_SEL);
    if (closeBtn) {
      closeBtn.click();
    } else {
      // Fallback: dispatch Escape so Empire's own handler fires.
      // Guarded: without the flag this re-entered our keydown handler endlessly.
      closing = true;
      try {
        modal.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
      } finally {
        closing = false;
      }
    }
    setTimeout(function () {
      if (lastTrigger && document.body.contains(lastTrigger)) lastTrigger.focus();
    }, 150);
  }
}


// ============================================
// ADA FIX: PageFly FAQ accordion
//
// ⚠️ Only targets known FAQ/accordion button
// patterns — NOT all .__pf buttons.
// Using '.__pf button' was breaking focus ring
// detection on all PageFly pages.
// ============================================
// Answer panel for a PageFly FAQ button: walk up a few levels and take the
// first following sibling block that has text and doesn't contain the button.
function findFaqPanel(btn) {
  var id = btn.getAttribute('aria-controls');
  if (id && document.getElementById(id)) return document.getElementById(id);
  var node = btn;
  for (var depth = 0; depth < 4 && node && node.parentElement; depth++) {
    var sib = node.nextElementSibling;
    while (sib) {
      if (!sib.contains(btn) && sib.textContent.trim().length > 0) return sib;
      sib = sib.nextElementSibling;
    }
    node = node.parentElement;
  }
  return null;
}

// Open = the panel actually takes up space and isn't hidden
function syncFaqExpanded(btn) {
  var panel = findFaqPanel(btn);
  if (!panel) return;
  var s = window.getComputedStyle(panel);
  var open = s.display !== 'none' && s.visibility !== 'hidden' &&
             !panel.hasAttribute('hidden') && panel.getAttribute('aria-hidden') !== 'true' &&
             panel.getBoundingClientRect().height > 1;
  btn.setAttribute('aria-expanded', open ? 'true' : 'false');
}

function fixPageFlyFAQ() {
  var faqButtons = document.querySelectorAll('button.pf-anchor');

  if (!faqButtons.length) {
    faqButtons = document.querySelectorAll(
      '.__pf .pf-accordion button, .__pf .pf-faq button, .__pf [class*="accordion"] button, .__pf [class*="faq"] button'
    );
  }

  faqButtons.forEach(function (btn) {
    if (btn.classList.contains('navmenu-button')) return;
    if (btn.dataset.adaFixed === 'true') return;
    if (btn.dataset.adaNavFixed === 'true') return;
    btn.dataset.adaFixed = 'true';

    if (!btn.getAttribute('aria-expanded')) btn.setAttribute('aria-expanded', 'false');

    // 10.22.2026 (BKL-146): aria-expanded stayed "false" after the answer opened.
    // The old check looked at the button's next sibling (often an icon) at
    // 200ms, mid-animation. Now: find the real answer panel (the nearest
    // following block with text that doesn't contain the button), link it with
    // aria-controls, and re-check after the animation settles.
    var panel = findFaqPanel(btn);
    if (panel) {
      if (!panel.id) panel.id = 'ada-faq-panel-' + Math.random().toString(36).substr(2, 7);
      btn.setAttribute('aria-controls', panel.id);
    }
    syncFaqExpanded(btn);

    btn.addEventListener('click', function () {
      [60, 450, 1000].forEach(function (ms) {
        setTimeout(function () {
          // PageFly accordions may close the other items: re-sync every FAQ button
          document.querySelectorAll('[data-ada-faq="true"]').forEach(syncFaqExpanded);
        }, ms);
      });
    });
    btn.dataset.adaFaq = 'true';

    // ⚠️ Only preventDefault on Enter/Space — NEVER on Tab
    // Preventing Tab would break focus ring detection
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        btn.click();
      }
    });
  });
}


// ============================================
// ADA FIX: Links and labels
// ============================================
// 10.22.2026 (BKL-112): name the link after the announcement text itself
// (e.g. "Read Bakell's Red 3-Free Statement...") instead of a generic label.
function fixAnnouncementBarLink() {
  document.querySelectorAll('a.announcement-bar-link').forEach(function (link) {
    if (link.textContent.trim()) return;
    var current = link.getAttribute('aria-label');
    if (current && current !== 'View current promotion') return;
    // start from the parent: the link's own class contains "announcement-bar"
    var bar = link.parentElement && link.parentElement.closest('.announcement-bar, [class*="announcement-bar"]');
    var text = bar ? bar.textContent.replace(/\s+/g, ' ').trim() : '';
    link.setAttribute('aria-label', text || 'View current promotion');
  });
}

function fixFooterShopifyLink() {
  document.querySelectorAll('.site-footer-credits a[href*="shopify.com"]').forEach(function (link) {
    if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', 'Powered by Shopify');
  });
}

function fixShopFullCollectionLinks() {
  document.querySelectorAll('a[data-pf-type="Button2"].pf-button-6').forEach(function (link) {
    if (link.dataset.adaLinkFixed === 'true') return;
    link.dataset.adaLinkFixed = 'true';
    var href = link.getAttribute('href') || '';
    var text = link.textContent.trim();
    if (!text) return;
    var match = href.match(/\/collections\/([^?#]+)/);
    if (match) {
      var name = match[1]
        .replace(/-/g, ' ')
        .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      if (name.toLowerCase() !== text.toLowerCase()) {
        link.setAttribute('aria-label', text + ' — ' + name);
      }
    }
  });
}

// 10.22.2026 (BKL-132): DISABLED. It hid every repeat of an href across the
// WHOLE page (not just the footer), which can hide the visible, useful copy of
// a link (e.g. mobile vs desktop menus). The duplicate footer block is already
// removed server-side (BKL-121), and duplicate links are not a WCAG failure.
function fixDuplicateFooterLinks() {
  return;
  var seen = {};
  document.querySelectorAll('a.navmenu-link').forEach(function (link) {
    var href = link.getAttribute('href') || '';
    if (!href) return;
    if (seen[href]) {
      link.setAttribute('aria-hidden', 'true');
      link.setAttribute('tabindex', '-1');
    } else {
      seen[href] = true;
    }
  });
}


// ============================================
// ADA FIX: CBB Shipping calculator tab order
// ============================================
function fixCBBShippingTabOrder() {
  var calculator = document.querySelector('.cbb-shipping-rates-calculator');
  if (!calculator || calculator.dataset.wmReordered === 'true') return;
  var addressSection = document.querySelector(
    '.cbb-shipping-rates-calculator-shipping-address-chooser'
  );
  var chooser = document.querySelector('.cbb-shipping-rates-calculator-chooser');
  var header  = document.querySelector('.cbb-shipping-rates-calculator-header');
  if (!addressSection || !chooser) return;
  if (header) header.insertAdjacentElement('afterend', addressSection);
  else calculator.insertBefore(addressSection, calculator.firstChild);
  var map      = chooser.querySelector('.cbb-shipping-rates-calculator-map');
  var rateList = chooser.querySelector('.cbb-shipping-rates-rate-list');
  if (rateList) chooser.insertBefore(rateList, chooser.firstChild);
  if (map) chooser.appendChild(map);
  calculator.dataset.wmReordered = 'true';
}

var cbbObserver = new MutationObserver(function () {
  var calc = document.querySelector('.cbb-shipping-rates-calculator');
  if (calc && calc.dataset.wmReordered !== 'true') {
    if (document.querySelector('.cbb-shipping-rates-calculator-shipping-address-chooser')) {
      setTimeout(fixCBBShippingTabOrder, 300);
    }
  }
});


// ============================================
// ADA FIX: Link-Buttons
//
// Shopify and PageFly output buttons as <a> tags
// styled to look like buttons. Screen readers
// correctly call them "links" and Space bar does
// not activate them (only Enter does on links).
//
// This fix:
//   1. Adds role="button" so screen readers
//      announce them as buttons
//   2. Adds Space key support to activate them
//   3. Skips same-page anchors (#) which should
//      remain links
//   4. MutationObserver covers dynamically loaded
//      PageFly content
// ============================================
function fixLinkButtons() {
  document.querySelectorAll(
    'a[class*="btn"], a[class*="button"], a.button, a.btn, ' +
    '.__pf a[class*="btn"], .__pf a[class*="button"], ' +
    'a[data-pf-type="Button"], ' +
    'a.atc-button, a.site-header-cart--button'
  ).forEach(function (el) {
    if (el.dataset.adaLinkButtonFixed) return;
    el.dataset.adaLinkButtonFixed = 'true';

    // 10.22.2026 (BKL-130, WCAG 4.1.2): a styled <a> that goes somewhere is a LINK,
    // whatever it looks like. Only anchors that act as in-page actions
    // (no href, href="#", or javascript:) are exposed as buttons.
    // The old check was inverted: it made real navigation links role="button".
    var href = (el.getAttribute('href') || '').trim();
    var isAction = href === '' || href === '#' || href.toLowerCase().indexOf('javascript:') === 0;
    if (!isAction) return;

    el.setAttribute('role', 'button');

    // Space key support — buttons activate on Space; links do not
    el.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        el.click();
      }
    });
  });
}

var linkButtonObserver = new MutationObserver(function (mutations) {
  var relevant = mutations.some(function (m) { return m.addedNodes.length > 0; });
  if (relevant) fixLinkButtons();
});


// ============================================
// ADA FIX: Product detail page price focus
//
// Price, discount and title on the product
// detail page are static elements — Tab skips
// them entirely. This fix creates a visually
// hidden but focusable summary element that
// announces the full product info in one clean
// screen reader announcement.
// ============================================
// 10.22.2026 (BKL-119 / BKL-116): prices and sale text now stay CURRENT.
// Before, the hidden price text was written once on page load, so after a
// customer picked another size, screen readers heard the old price
// (e.g. $9.98 while $389.98 was on screen). Now every price container is
// watched; when its visible price changes, the hidden text, the product
// summary and the product-card description are rewritten.
// The sale badge stays aria-hidden (its text is split into pieces), but its
// current visible text ("Save 23%") is included in the descriptions, and
// 0% / hidden badges are skipped.

function getSaleText(scope) {
  if (!scope) return '';
  var b = scope.querySelector('[data-badge-sales-range]');
  if (!b || b.offsetParent === null) return '';
  var t = b.textContent.replace(/\s+/g, ' ').trim();
  if (!t || /(^|[^\d.])0(\.0+)?\s*%/.test(t)) return '';
  return t;
}

function readPriceInfo(container) {
  var min = container.querySelector('[data-price-min]');
  var max = container.querySelector('[data-price-max]');
  var single = container.querySelector('[data-price]');
  if (min && max) {
    return { text: 'Price from ' + min.textContent.trim() + ' to ' + max.textContent.trim(), hide: [min, max], min: min, max: max };
  } else if (min) {
    return { text: 'Price ' + min.textContent.trim(), hide: [min] };
  } else if (single) {
    return { text: 'Price ' + single.textContent.trim(), hide: [single] };
  }
  return null;
}

function applyAdaPrice(container) {
  var info = readPriceInfo(container);
  if (!info || info.text.replace(/^Price (from )?/, '').trim() === '') return;

  var srText = container.querySelector('.ada-price-text');
  // Nothing changed — stop here (also prevents an observer loop)
  if (srText && container.dataset.adaPrice === info.text && srText.textContent === info.text) return;

  container.removeAttribute('aria-label');
  container.dataset.adaPrice = info.text;
  container.dataset.adaPriceFixed = 'true';

  if (!srText) {
    srText = document.createElement('span');
    srText.className = 'visually-hidden ada-price-text';
    info.hide[0].parentNode.insertBefore(srText, info.hide[0]);
  }
  srText.textContent = info.text;

  info.hide.forEach(function (el) { el.setAttribute('aria-hidden', 'true'); });

  // Hide the " – " separator between min and max so it isn't read alone
  if (info.min && info.max && info.min.parentNode === info.max.parentNode) {
    var node = info.min.nextSibling;
    while (node && node !== info.max) {
      var next = node.nextSibling;
      if (node.nodeType === 3 && node.textContent.trim()) {
        var wrap = document.createElement('span');
        wrap.setAttribute('aria-hidden', 'true');
        node.parentNode.insertBefore(wrap, node);
        wrap.appendChild(node);
      } else if (node.nodeType === 1 && node !== srText) {
        node.setAttribute('aria-hidden', 'true');
      }
      node = next;
    }
  }

  // Keep dependent descriptions in sync
  if (container.closest('.product-block--price')) updateProductSummary();
  var card = container.closest('.productgrid--item');
  if (card) updateCardDescription(card);
}

function fixProductPriceRange() {
  document.querySelectorAll('[data-price-container]').forEach(function (container) {
    applyAdaPrice(container);
    if (container.dataset.adaPriceObserved === 'true') return;
    container.dataset.adaPriceObserved = 'true';
    new MutationObserver(function () {
      applyAdaPrice(container);
    }).observe(container, { childList: true, subtree: true, characterData: true });
  });
}

// ---------- Product detail page summary (BKL-119) ----------
function buildProductSummaryText() {
  var titleEl = document.querySelector('h1');
  var title = titleEl ? titleEl.textContent.trim() : '';
  var priceEl = document.querySelector('.product-block--price [data-price-container]');
  var price = priceEl ? (priceEl.dataset.adaPrice || '') : '';
  if (!price && priceEl) {
    var single = priceEl.querySelector('[data-price]');
    if (single) price = 'Price ' + single.textContent.trim();
  }
  var compareEl = document.querySelector('.product-block--price [data-compare-price], .product-block--price .price--compare');
  if (compareEl && compareEl.offsetParent !== null) {
    var compareText = compareEl.textContent.trim();
    if (compareText && price) price = price + ', was ' + compareText;
  }
  var badge = getSaleText(document.querySelector('.product-block--price')) ||
              getSaleText(document.querySelector('.product--container, .product-main, form[action*="/cart/add"]'));
  return [title, price, badge].filter(Boolean).join(', ');
}

function updateProductSummary() {
  var summary = document.getElementById('ada-product-summary');
  if (!summary) return;
  var text = buildProductSummaryText();
  if (text && summary.textContent !== text) summary.textContent = text;
}

function fixProductDetailPrice() {
  var priceBlock = document.querySelector('.product-block--price');
  if (!priceBlock) return;

  // Already created: just refresh the text (no remove/re-create, keeps focus)
  if (document.getElementById('ada-product-summary')) { updateProductSummary(); return; }

  var text = buildProductSummaryText();
  if (!text) return;

  var summary = document.createElement('div');
  summary.id = 'ada-product-summary';
  summary.setAttribute('tabindex', '0');
  // Text content instead of aria-label (not allowed on a plain <div>); 1px sr-only size
  summary.textContent = text;
  summary.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;top:0;left:0;pointer-events:none;';

  summary.addEventListener('focus', function () {
    var h1 = document.querySelector('h1');
    var pb = document.querySelector('.product-block--price');
    if (h1) h1.classList.add('ada-detail-focused');
    if (pb) pb.classList.add('ada-detail-focused');
  });
  summary.addEventListener('blur', function () {
    var h1 = document.querySelector('h1');
    var pb = document.querySelector('.product-block--price');
    if (h1) h1.classList.remove('ada-detail-focused');
    if (pb) pb.classList.remove('ada-detail-focused');
  });

  priceBlock.parentNode.insertBefore(summary, priceBlock);
}


// ============================================
// ADA FIX 10.22.2026: Announce quantity changes (WCAG 4.1.3, best practice)
//
// The − / + buttons ("Decrease/Increase quantity by 1") change the
// quantity field, but screen readers don't announce the new value.
// After a click, read the field and announce "Quantity 2" once, politely,
// in a visually hidden status region. Rapid presses are debounced so only
// the final value is read. Price changes are still announced by the
// theme's own .product-pricing live region.
// ============================================
function fixQuantityAnnouncements() {
  if (window.__adaQtyFixed) return;
  window.__adaQtyFixed = true;

  var status = document.getElementById('ada-qty-status');
  if (!status) {
    status = document.createElement('div');
    status.id = 'ada-qty-status';
    status.className = 'visually-hidden';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    document.body.appendChild(status);
  }

  var timer = null;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quantity-selector__button, .quantity-increment, .quantity-decrement');
    if (!btn) return;
    var wrap = btn.closest('.quantity-selector, form, [data-product-form]') || btn.parentElement;
    var input = wrap && wrap.querySelector('input[name="quantity"], input[type="number"], .quantity-selector__input');
    if (!input) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      // Clear first so the same value is announced again if repeated
      status.textContent = '';
      setTimeout(function () { status.textContent = 'Quantity ' + input.value; }, 50);
    }, 400);
  });
}


// ============================================
// ADA FIX: Product card title link aria-describedby
//
// Tab lands on the product title link. Price and sale text live in sibling
// divs that Tab never reaches. aria-describedby points the title link at a
// visually hidden span so screen readers announce the product name, then
// the price and sale text. 10.22.2026: the span is refreshed whenever the
// card's price changes (BKL-116).
// ============================================
function cardDescriptionText(card) {
  var priceEl = card.querySelector('[data-price-container]');
  var price = priceEl ? (priceEl.dataset.adaPrice || priceEl.textContent.replace(/\s+/g, ' ').trim()) : '';
  return [price, getSaleText(card)].filter(Boolean).join(', ');
}

function updateCardDescription(card) {
  var id = card.dataset.adaDescId;
  var span = id ? document.getElementById(id) : null;
  if (!span) return;
  var text = cardDescriptionText(card);
  if (text && span.textContent !== text) span.textContent = text;
}

function fixProductCardImageLinks() {
  document.querySelectorAll('.productgrid--item').forEach(function (card) {
    // Target the title link specifically — the image link has tabindex="-1"
    var titleLink = card.querySelector('p.productitem--title a');
    if (!titleLink) return;

    // Already fixed: refresh the text in case the price/badge changed
    if (titleLink.dataset.adaDescFixed === 'true') { updateCardDescription(card); return; }

    var text = cardDescriptionText(card);
    if (!text) return;
    titleLink.dataset.adaDescFixed = 'true';

    var span = document.createElement('span');
    span.id = 'ada-price-' + Math.random().toString(36).substr(2, 9);
    span.className = 'visually-hidden';
    span.textContent = text;
    card.appendChild(span);
    card.dataset.adaDescId = span.id;

    titleLink.setAttribute('aria-describedby', span.id);

    // Focus ring around the whole card while the title link is focused
    titleLink.addEventListener('focus', function () { card.classList.add('ada-card-focused'); });
    titleLink.addEventListener('blur', function () { card.classList.remove('ada-card-focused'); });
  });
}


// ============================================
// ADA FIX: Sale badge
// The badge's text is split into pieces that screen readers read badly,
// so the badge itself stays hidden from them. Its CURRENT text is read as
// part of the product-card description and the product summary instead
// (see getSaleText). 10.22.2026 (BKL-116).
// ============================================
function fixSaleBadge() {
  document.querySelectorAll('[data-badge-sales-range]').forEach(function (badge) {
    badge.setAttribute('aria-hidden', 'true');
  });
}


// ============================================
// ADA FIX: Disclosure listbox arrow key navigation
//
// Screen readers intercept arrow keys in browse
// mode. The only way to pass arrow keys through
// to JS is to move actual focus INTO an element
// with role="option" inside role="listbox" —
// this triggers application mode in the screen
// reader so arrow keys reach the page JS.
//
// This fix covers ALL [data-disclosure-toggle]
// dropdowns sitewide (country, currency, etc).
//
// Behavior:
//   - Open: focus moves to selected/first option
//   - ArrowDown/Up: navigate between options
//   - Home/End: jump to first/last option
//   - Enter/Space: activate focused option
//   - Escape: close and return focus to trigger
//   - aria-expanded: kept in sync with open state
//   - aria-activedescendant: tracks active option
// ============================================
function fixDisclosureListbox() {
  document.querySelectorAll('[data-disclosure-toggle]').forEach(function (btn) {
    if (btn.dataset.adaListboxFixed === 'true') return;
    btn.dataset.adaListboxFixed = 'true';

    var listId = btn.getAttribute('aria-controls');
    var list = listId ? document.getElementById(listId) : null;
    if (!list) return;

    // Ensure list has role=listbox
    if (!list.getAttribute('role')) list.setAttribute('role', 'listbox');

    // Give each option a unique ID and ensure role=option
    var options = Array.from(list.querySelectorAll('[role="option"], li a, li button'));
    options.forEach(function (opt, i) {
      if (!opt.id) opt.id = listId + '-opt-' + i;
      if (!opt.getAttribute('role')) opt.setAttribute('role', 'option');
      opt.setAttribute('tabindex', '-1');
    });

    // Watch for open/close — update aria-expanded and move focus in
    var observer = new MutationObserver(function () {
      var isOpen = window.getComputedStyle(list).display !== 'none'
        && list.getAttribute('hidden') === null
        && !list.classList.contains('is-hidden');

      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (isOpen && options.length) {
        var selected = options.find(function (o) {
          return o.getAttribute('aria-selected') === 'true';
        }) || options[0];

        btn.setAttribute('aria-activedescendant', selected.id);

        // Move actual DOM focus into the list — this is what switches
        // the screen reader from browse mode to application mode
        setTimeout(function () { selected.focus(); }, 50);
      } else {
        btn.removeAttribute('aria-activedescendant');
      }
    });

    observer.observe(list, {
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden']
    });

    // Arrow key + Home/End/Escape/Enter handling on the list
    list.addEventListener('keydown', function (e) {
      var opts = Array.from(list.querySelectorAll('[role="option"]'));
      if (!opts.length) return;

      var currentIdx = opts.indexOf(document.activeElement);

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        var next = opts[Math.min(currentIdx + 1, opts.length - 1)];
        next.focus();
        btn.setAttribute('aria-activedescendant', next.id);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        var prev = opts[Math.max(currentIdx - 1, 0)];
        prev.focus();
        btn.setAttribute('aria-activedescendant', prev.id);
      } else if (e.key === 'Home') {
        e.preventDefault();
        opts[0].focus();
        btn.setAttribute('aria-activedescendant', opts[0].id);
      } else if (e.key === 'End') {
        e.preventDefault();
        opts[opts.length - 1].focus();
        btn.setAttribute('aria-activedescendant', opts[opts.length - 1].id);
      } else if (e.key === 'Escape') {
        e.preventDefault();
        btn.click();
        btn.focus();
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (document.activeElement && document.activeElement !== btn) {
          document.activeElement.click();
        }
      }
    });
  });
}
// ============================================
// ADA FIX: Search flydown keyboard navigation
//
// Uses same pattern as fixDisclosureListbox —
// moves actual DOM focus into role=option items
// inside role=listbox to trigger application
// mode in screen readers so arrow keys work.
// Hook: watches style on .search-flydown for
// --open-height changing (same as currency list
// watches style/class/hidden on its list).
// ============================================
function fixSearchFlydown() {
  var input = document.querySelector('input.live-search-form-field');
  if (!input || input._adaSearchFixed) return;
  var flydown = document.querySelector('.search-flydown');
  if (!flydown) return;

  input._adaSearchFixed = true;

  flydown.setAttribute('role', 'listbox');
  flydown.setAttribute('id', 'search-flydown-grid');
  flydown.setAttribute('aria-label', 'Search suggestions');

  function getOptions() {
    return Array.from(flydown.querySelectorAll(
      '.search-flydown__list-item a, .search-flydown--product, .search-flydown__pages-posts-items a'
    ));
  }

  function setupOptions() {
    // Give results tabindex=0 so Tab reaches them
    getOptions().forEach(function(opt, i) {
      if (!opt.id) opt.id = 'search-option-' + i;
      opt.setAttribute('role', 'option');
      opt.setAttribute('aria-selected', 'false');
      opt.setAttribute('tabindex', '0');
    });

    // Remove the Search button and quicklinks from tab order
    // so Tab goes straight to results, not past them
    flydown.querySelectorAll(
      '.search-flydown__continue, .search-flydown--quicklinks-link'
    ).forEach(function(el) {
      el.setAttribute('tabindex', '-1');
    });
  }

  new MutationObserver(function() {
    setupOptions();
  }).observe(flydown, { childList: true, subtree: true });

  setupOptions();

  // ADA FIX 10.22.2026: fixNavSummaryLabels() used to be defined here, inside
  // fixSearchFlydown(), so the call in DOMContentLoaded threw
  // "ReferenceError: fixNavSummaryLabels is not defined" and stopped everything
  // after it (including the CBB shipping watcher). Moved to top level below.

  // ADA Fix - 5.26.2026 : DO NOT auto-focus results on open — this breaks typing.
  // Screen readers announce results via aria-activedescendant
  // on the input. Focus only moves to results on ArrowDown.
  new MutationObserver(function() {
    var isOpen = input.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      setTimeout(function() {
        setupOptions();
        var opts = getOptions();
        if (!opts.length) return;
        // Set aria-activedescendant so screen reader announces
        // first result — but DO NOT call first.focus()
        input.setAttribute('aria-activedescendant', opts[0].id);
      }, 100);
    } else {
      input.removeAttribute('aria-activedescendant');
    }
  }).observe(flydown, {
    attributes: true,
    attributeFilter: ['style']
  });

  flydown.addEventListener('keydown', function(e) {
    var opts = getOptions();
    if (!opts.length) return;
    var idx = opts.indexOf(document.activeElement);

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      var next = opts[Math.min(idx + 1, opts.length - 1)];
      next.focus();
      input.setAttribute('aria-activedescendant', next.id);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (idx <= 0) {
        input.focus();
        input.removeAttribute('aria-activedescendant');
      } else {
        var prev = opts[idx - 1];
        prev.focus();
        input.setAttribute('aria-activedescendant', prev.id);
      }
    } else if (e.key === 'Home') {
      e.preventDefault();
      opts[0].focus();
      input.setAttribute('aria-activedescendant', opts[0].id);
    } else if (e.key === 'End') {
      e.preventDefault();
      opts[opts.length - 1].focus();
      input.setAttribute('aria-activedescendant', opts[opts.length - 1].id);
    } else if (e.key === 'Escape') {
      e.preventDefault();
      input.focus();
      var ls = input.closest('.live-search');
      if (ls) ls.classList.remove('live-search--focused', 'live-search--active');
    } else if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (document.activeElement && document.activeElement !== input) {
        document.activeElement.click();
      }
    }
  });

  input.addEventListener('input', function() {
    input.removeAttribute('aria-activedescendant');
  });
}

// ============================================
// ADA FIX: Nav summary elements aria-label (WCAG 4.1.2)
//
// <summary> tags used as nav dropdowns need an
// accessible name. Adds aria-label from the
// visible text of each summary element.
// 10.22.2026: moved to top level (was nested inside
// fixSearchFlydown and never ran) and selector widened
// to summary.navmenu-link so every top-level item matches.
// ============================================
function fixNavSummaryLabels() {
  document.querySelectorAll('summary.navmenu-link-parent, summary.navmenu-link').forEach(function (summary) {
    if (summary.dataset.adaSummaryFixed === 'true') return;
    summary.dataset.adaSummaryFixed = 'true';

    // Get visible text, excluding the chevron icon span
    var icon = summary.querySelector('.navmenu-icon');
    var label = '';
    summary.childNodes.forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        label += node.textContent;
      } else if (node !== icon && node.nodeType === Node.ELEMENT_NODE) {
        label += node.textContent;
      }
    });
    label = label.trim();
    if (label && !summary.getAttribute('aria-label')) summary.setAttribute('aria-label', label);
  });
}

// ============================================
// ADA FIX: Back-to-top button name (WCAG 4.1.2)
//
// The button is icon-only, so it had no
// accessible name. Adds "Back to top" when the
// button has no text of its own.
// ============================================
function fixBackToTop() {
  document.querySelectorAll('.back-to-top__button').forEach(function (btn) {
    // innerText (not textContent) so a hidden .back-to-top__button-label doesn't count as a name
    var visibleText = typeof btn.innerText === 'string' ? btn.innerText : '';
    if (btn.getAttribute('aria-label') || visibleText.trim()) return;
    btn.setAttribute('aria-label', 'Back to top');
  });
}

// ============================================
// ADA FIX 10.22.2026 (BKL-110, WCAG 2.4.1): Skip link actually moves focus
//
// "Skip to content" points at <main id="site-main" tabindex="-1">, but
// <main> is display:contents (no box), so browsers can't focus it: the
// hash changed while focus stayed on <body> and the next Tab went back
// into the header. Now the link focuses the first visible block inside
// <main> and scrolls to it. adaFocusMain() can also be used by the
// keyboard-shortcuts panel ("Main").
// ============================================
function adaGetMainTarget() {
  var main = document.getElementById('site-main') || document.querySelector('main, [role="main"]');
  if (!main) return null;
  if (main.getBoundingClientRect().height > 0 && window.getComputedStyle(main).display !== 'contents') return main;
  var queue = Array.prototype.slice.call(main.children);
  while (queue.length) {
    var el = queue.shift();
    var s = window.getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden') continue;
    if (s.display === 'contents') { queue = Array.prototype.slice.call(el.children).concat(queue); continue; }
    if (el.getBoundingClientRect().height > 0) return el;
  }
  return main;
}

function adaFocusMain() {
  var target = adaGetMainTarget();
  if (!target) return;
  if (!target.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(target.tagName)) {
    target.setAttribute('tabindex', '-1');
  }
  target.setAttribute('data-ada-skip-target', 'true');
  target.focus({ preventScroll: true });
  target.scrollIntoView({ block: 'start' });
}
window.adaFocusMain = adaFocusMain;

function fixSkipLink() {
  if (window.__adaSkipFixed) return;
  window.__adaSkipFixed = true;
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a.skip-to-main, a[href="#site-main"]');
    if (!link) return;
    e.preventDefault();
    adaFocusMain();
  });
}


// ============================================
// ADA FIX 10.22.2026 (BKL-147, WCAG 1.3.1 / 4.1.2 / 3.3.2):
// Cart shipping calculator (CBB app) renders select#country and
// select#region with EMPTY <label>s, so they have no accessible name.
// Put the name into the empty label (visually hidden, so the layout does
// not change). Re-runs when the app re-renders the form.
// ============================================
function adaFieldName(el) {
  var key = ((el.id || '') + ' ' + (el.name || '') + ' ' + (el.className || '')).toLowerCase();
  if (/country/.test(key)) return 'Country';
  if (/region|province|state/.test(key)) return 'State / Province';
  if (/zip|postal/.test(key)) return 'ZIP / Postal code';
  if (/city/.test(key)) return 'City';
  return '';
}

function adaHasName(el) {
  if ((el.getAttribute('aria-label') || '').trim() || el.getAttribute('aria-labelledby') || (el.getAttribute('title') || '').trim()) return true;
  return Array.prototype.some.call(el.labels || [], function (l) { return l.textContent.trim().length > 0; });
}

function fixShippingFieldLabels() {
  var scope = document.getElementById('cart-shipping-keyboard-region') ||
              document.querySelector('.cbb-shipping-rates-calculator');
  if (!scope) return;
  scope.querySelectorAll('select, input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"])').forEach(function (el) {
    if (adaHasName(el)) return;
    var name = adaFieldName(el);
    if (!name) return;
    var label = el.labels && el.labels[0];
    if (label) {
      var span = document.createElement('span');
      span.className = 'visually-hidden';
      span.textContent = name;
      label.appendChild(span);
    } else {
      el.setAttribute('aria-label', name);
    }
  });
}

function watchShippingFieldLabels() {
  fixShippingFieldLabels();
  var region = document.getElementById('cart-shipping-keyboard-region');
  if (!region || region.dataset.adaLabelsObserved === 'true') return;
  region.dataset.adaLabelsObserved = 'true';
  // Only adds text when a name is missing, so this cannot loop
  new MutationObserver(function () { fixShippingFieldLabels(); })
    .observe(region, { childList: true, subtree: true });
}


// ============================================
// ADA FIX 10.22.2026 (BKL-120): country/currency list selected state
// The current country (e.g. United States) was not marked as selected,
// so opening the list started on the first option (Afghanistan) and
// screen readers couldn't tell which one is current. Mark the current
// option aria-selected="true" (others "false") and name the listbox.
// ============================================
function fixDisclosureSelectedState() {
  document.querySelectorAll('[data-disclosure-toggle][aria-controls]').forEach(function (btn) {
    var list = document.getElementById(btn.getAttribute('aria-controls'));
    if (!list) return;
    var current = (btn.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    var label = list.getAttribute('aria-label');
    if (!label || label.trim().toLowerCase() === current) list.setAttribute('aria-label', 'Country/region');
    list.querySelectorAll('[role="option"]').forEach(function (opt) {
      var li = opt.closest('li');
      var text = opt.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      var isCurrent = opt.getAttribute('aria-current') === 'true' ||
        /--current|is-active|is-selected/.test(opt.className + ' ' + (li ? li.className : '')) ||
        (text && current && (text === current || current.indexOf(text) === 0));
      opt.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
    });
  });
}


// ============================================
// ADA FIX 10.22.2026: Back-to-top focus + position
//
// 1. WCAG 2.4.3: Enter scrolled to the top but focus stayed on the button
//    at the bottom, so the next Tab went into the footer. Now focus moves
//    to the top of the page too (the "Skip to content" link, else the
//    first header control), so the next Tab continues from the top.
// 2. WCAG 2.4.11: the button sat underneath the Zoho chat launcher
//    (both bottom-right). It is now raised above the chat whenever they
//    would overlap. Re-checked on scroll/resize because the chat loads late.
// ============================================
function fixBackToTopFocus() {
  if (window.__adaBttFocus) return;
  window.__adaBttFocus = true;
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.back-to-top__button')) return;
    setTimeout(function () {
      var top = document.querySelector('a.skip-to-main') ||
                document.querySelector('header a[href], header button, [data-site-header] a[href]');
      if (top) top.focus({ preventScroll: true });
    }, 50);
  });
}

function getFixedAncestor(el) {
  while (el && el !== document.body) {
    if (window.getComputedStyle(el).position === 'fixed') return el;
    el = el.parentElement;
  }
  return null;
}

function raiseBackToTopAboveChat() {
  var btn = document.querySelector('.back-to-top__button');
  var box = btn && getFixedAncestor(btn);
  var chat = document.querySelector('#zsiq_float, .zsiq_floatmain, [class*="zsiq_float"]');
  if (!box || !chat) return;
  var a = box.getBoundingClientRect();
  var c = chat.getBoundingClientRect();
  if (!a.width || !c.width) return; // one of them isn't shown right now
  var overlapsX = a.left < c.right && a.right > c.left;
  if (!overlapsX) return;
  var neededBottom = Math.ceil(window.innerHeight - c.top + 12); // 12px gap above the chat
  var currentBottom = parseFloat(window.getComputedStyle(box).bottom) || 0;
  if (currentBottom < neededBottom) box.style.setProperty('bottom', neededBottom + 'px', 'important');
}

function fixBackToTopPosition() {
  if (window.__adaBttPos) return;
  window.__adaBttPos = true;
  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(raiseBackToTopAboveChat, 150); }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  [1500, 4000, 8000].forEach(function (ms) { setTimeout(raiseBackToTopAboveChat, ms); });
}


// ============================================
// ADA FIX 10.22.2026: Chat launcher must not cover the cookie banner
// (WCAG 2.4.11 Focus Not Obscured; consent buttons must be equally usable)
//
// The Zoho chat launcher + "We're Online!" bubble sat on top of the
// cookie banner's Decline button. Decision 10.22.2026: HIDE the chat
// while the cookie banner is showing; show it again (unchanged) once the
// visitor accepts, declines or closes the banner.
// ============================================
function getConsentBanner() {
  var b = document.getElementById('shopify-pc__banner');
  if (b) return b;
  // Fallback: a fixed bar that contains both Accept and Decline buttons
  var buttons = Array.prototype.slice.call(document.querySelectorAll('button'));
  var decline = buttons.filter(function (x) { return /^\s*decline\s*$/i.test(x.textContent); })[0];
  return decline ? getFixedAncestor(decline) : null;
}

// "Showing" = really on screen. After a choice is made, Shopify can leave the
// banner element in the page but slide it off-screen, fade it out or mark it
// hidden, so size alone is not enough.
function isConsentBannerShowing(banner) {
  if (!banner) return false;
  if (banner.hasAttribute('hidden') || banner.getAttribute('aria-hidden') === 'true') return false;
  var el = banner;
  while (el && el !== document.documentElement) {
    var s = window.getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden' || parseFloat(s.opacity) === 0) return false;
    el = el.parentElement;
  }
  var r = banner.getBoundingClientRect();
  if (r.height < 10 || r.width < 10) return false;
  // must actually be inside the viewport (not slid below or above it)
  if (r.top >= window.innerHeight - 5 || r.bottom <= 5) return false;
  // something must really be painted at the banner's centre
  if (document.elementFromPoint) {
    var x = Math.min(Math.max(r.left + r.width / 2, 1), window.innerWidth - 1);
    var y = Math.min(Math.max(r.top + Math.min(r.height / 2, 20), 1), window.innerHeight - 1);
    var hit = document.elementFromPoint(x, y);
    if (hit && !banner.contains(hit) && !hit.contains(banner)) {
      // covered by something else entirely (e.g. off-screen transform) — not showing
      var chatHit = hit.closest && hit.closest('[class*="zsiq"], [id*="zsiq"]');
      if (!chatHit) return false;
    }
  }
  return true;
}

function keepChatOffConsentBanner() {
  var chatBtn = document.querySelector('#zsiq_float, .zsiq_floatmain, [class*="zsiq_float"]');
  var chat = chatBtn && (getFixedAncestor(chatBtn) || chatBtn);
  if (!chat) return;

  var banner = getConsentBanner();
  var bannerShowing = isConsentBannerShowing(banner);

  if (bannerShowing) {
    if (!chat.hasAttribute('data-ada-chat-hidden')) {
      chat.setAttribute('data-ada-chat-hidden', chat.style.getPropertyValue('display') || '');
      // If keyboard focus is inside the chat, move it to the banner first
      if (chat.contains(document.activeElement)) {
        var first = banner.querySelector('button, a[href], [tabindex]:not([tabindex="-1"])');
        if (first) first.focus();
      }
      chat.style.setProperty('display', 'none', 'important');
    }
  } else if (chat.hasAttribute('data-ada-chat-hidden')) {
    var orig = chat.getAttribute('data-ada-chat-hidden');
    if (orig) chat.style.setProperty('display', orig); else chat.style.removeProperty('display');
    chat.removeAttribute('data-ada-chat-hidden');
  }
  raiseBackToTopAboveChat();
}

function fixChatOverConsent() {
  if (window.__adaChatConsent) return;
  window.__adaChatConsent = true;
  keepChatOffConsentBanner();

  // React the moment the chat widget or the banner is added to the page,
  // so the chat icon doesn't flash before being hidden. (Both apps add their
  // elements directly to <body>, so only direct children are watched.)
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) { keepChatOffConsentBanner(); return; }
    }
  }).observe(document.body, { childList: true });

  // Fast checks while the page is loading (banner slides in), then once a second
  // (the banner can be reopened from "Manage preferences").
  var fast = setInterval(keepChatOffConsentBanner, 150);
  setTimeout(function () { clearInterval(fast); }, 6000);
  setInterval(keepChatOffConsentBanner, 1000);
  window.addEventListener('resize', keepChatOffConsentBanner);
  document.addEventListener('transitionend', keepChatOffConsentBanner, true);
}


// ============================================
// Run ALL fixes
// ============================================
document.addEventListener('DOMContentLoaded', function () {

  // Focus ring stylesheet
  injectFocusStyles();
  setTimeout(injectFocusStyles, 1000);
  setTimeout(injectFocusStyles, 3000);

  // PageFly circular image links — wrap in real <a> for keyboard access
  fixPageFlyImageLinks();
  setTimeout(fixPageFlyImageLinks, 1500);
  setTimeout(fixPageFlyImageLinks, 3500);

  // Sale badge — hidden from screen readers (unreliable across variants)
  fixSaleBadge();
  setTimeout(fixSaleBadge, 1500);
  setTimeout(fixSaleBadge, 3500);

  // Product price range — announce min/max clearly to screen readers
  fixProductPriceRange();
  setTimeout(fixProductPriceRange, 1500);
  setTimeout(fixProductPriceRange, 3500);

  // Product detail page price — make price container focusable tab stop
  // Must run after fixProductPriceRange and fixSaleBadge so aria-labels are ready
  setTimeout(fixProductDetailPrice, 3000);
  setTimeout(fixProductDetailPrice, 5000);

  // Product card title link — combine title + price + badge into one aria-label
  // Must run after fixSaleBadge and fixProductPriceRange so aria-labels are ready
  setTimeout(fixProductCardImageLinks, 3000);
  setTimeout(fixProductCardImageLinks, 5000);

  // Disclosure listbox — arrow keys + screen reader application mode
  fixDisclosureListbox();
  setTimeout(fixDisclosureListbox, 1500);
  setTimeout(fixDisclosureListbox, 3500);

  // Search flydown — screen reader arrow key navigation
  fixSearchFlydown();
  setTimeout(fixSearchFlydown, 1500);
  setTimeout(fixSearchFlydown, 3500);

  // Quickshop modal: focus trap + Escape + return focus
  fixQuickshop();

  // CBB shipping
  fixCBBShippingTabOrder();
  setTimeout(fixCBBShippingTabOrder, 1000);
  setTimeout(fixCBBShippingTabOrder, 3000);

  // FAQ — delayed to allow PageFly to render its buttons first
  setTimeout(fixPageFlyFAQ, 2500);
  setTimeout(fixPageFlyFAQ, 4500);

  // Links
  fixAnnouncementBarLink();
  fixFooterShopifyLink();
  setTimeout(fixShopFullCollectionLinks, 1500);
  setTimeout(fixShopFullCollectionLinks, 3000);
  setTimeout(fixDuplicateFooterLinks, 500);

  // Link-buttons: role=button + Space key
  fixLinkButtons();
  setTimeout(fixLinkButtons, 1000);
  setTimeout(fixLinkButtons, 3000);
  linkButtonObserver.observe(document.body, { childList: true, subtree: true });

  // Nav summary aria-labels
  fixNavSummaryLabels();
  setTimeout(fixNavSummaryLabels, 1500);
  setTimeout(fixNavSummaryLabels, 3500);

  // Quantity − / + announcements
  fixQuantityAnnouncements();

  // Skip link moves focus into the content (BKL-110)
  fixSkipLink();

  // Cart shipping field names (BKL-147) — CBB loads late
  watchShippingFieldLabels();
  setTimeout(watchShippingFieldLabels, 1500);
  setTimeout(watchShippingFieldLabels, 3500);

  // Country list selected state (BKL-120) — after fixDisclosureListbox runs
  setTimeout(fixDisclosureSelectedState, 1600);
  setTimeout(fixDisclosureSelectedState, 3600);

  // Back-to-top button name, focus and position
  fixBackToTop();
  setTimeout(fixBackToTop, 1500);
  fixBackToTopFocus();
  fixBackToTopPosition();

  // Chat launcher stays clear of the cookie banner
  fixChatOverConsent();

  // CBB watcher
  var cartShipping = document.getElementById('cart-shipping-keyboard-region');
  if (cartShipping) cbbObserver.observe(cartShipping, { childList: true, subtree: true });

});


// ============================================
// FAQ Toggle and Search (custom Bakell FAQs)
// ============================================
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.faq-item .question').forEach(function (item, i) {
    // 10.22.2026 (BKL-136, WCAG 2.1.1 / 4.1.2): if the question isn't a native
    // <button>, make it act like one (role, Tab stop, Enter/Space) and link it
    // to its answer. Long-term: change .question to a <button> in the template.
    if (item.tagName !== 'BUTTON') {
      if (!item.getAttribute('role')) item.setAttribute('role', 'button');
      if (!item.hasAttribute('tabindex')) item.setAttribute('tabindex', '0');
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          item.click();
        }
      });
    }
    var ans = item.nextElementSibling;
    if (ans) {
      if (!ans.id) ans.id = 'faq-answer-' + i;
      item.setAttribute('aria-controls', ans.id);
    }
    if (!item.hasAttribute('aria-expanded')) {
      item.setAttribute('aria-expanded', item.parentElement.classList.contains('open') ? 'true' : 'false');
    }

    item.addEventListener('click', function () {
      var faqItem = item.parentElement;
      var answer  = item.nextElementSibling;
      if (faqItem.classList.contains('open')) {
        faqItem.classList.remove('open');
        answer.style.display = 'none';
        item.setAttribute('aria-expanded', 'false');
      } else {
        faqItem.parentElement.querySelectorAll('.faq-item').forEach(function (fi) {
          fi.classList.remove('open');
          fi.querySelector('.answer').style.display = 'none';
          fi.querySelector('.question').setAttribute('aria-expanded', 'false');
        });
        faqItem.classList.add('open');
        answer.style.display = 'block';
        item.setAttribute('aria-expanded', 'true');
      }
    });
  });
});

function filterFAQ(faqId, inputId) {
  var faqSection = document.getElementById(faqId);
  var input      = document.getElementById(inputId);
  if (!faqSection || !input) { console.error('FAQ section or input not found.'); return; }
  var filter = input.value.toLowerCase();
  faqSection.querySelectorAll('.faq-item').forEach(function (item) {
    item.style.display =
      item.querySelector('.question').textContent.toLowerCase().indexOf(filter) > -1 ? '' : 'none';
  });
}